// promoTileAnalytics.js

/**
 * Event handler for promotional tile clicks that sends analytics data to Adobe DataLayer.
 *
 * This function listens for click events on promotional tiles with the data attribute
 * `data-datalayer-id="kds-element-promotile"` and extracts analytics data from the
 * clicked element to push to the Adobe DataLayer for tracking purposes.
 *
 * The function performs the following operations:
 * 1. Finds the closest promotional tile element using the CSS selector
 * 2. Extracts event information from `data-datalayer-data` attribute
 * 3. Extracts component information from `data-datalayer-component` attribute
 * 4. Pushes a 'cmp:click' event to Adobe DataLayer with page, event, and component data
 *
 * Note: Requires window.adobeDataLayer and window.pageObj to be available globally.
 *
 * @export
 * @function handlePromoTileDatalayerClick
 * @param {Event} e - The DOM click event object containing the target element
 * @return {void}
 * @example
 * // Add event listener to document for promo tile clicks
 * document.addEventListener('click', handlePromoTileDatalayerClick);
 * @since 1.0.0
 */
export const handlePromoTileDatalayerClick = e => {
  const target = e.target.closest('[data-datalayer-id="kds-element-promotile"]')
  if (target) {
    console.log("Promo Tile Clicked", target.attributes)
    const eventInfo =
      JSON.parse(target?.attributes?.["data-datalayer-data"]?.nodeValue) || "{}"

    const componentInfo =
      JSON.parse(target?.attributes?.["data-datalayer-component"]?.nodeValue) ||
      "{}"

    if (typeof window !== "undefined" && window.adobeDataLayer) {
      const pageEvent = window.pageObj || {}

      window.adobeDataLayer.push({
        event: "cmp:click",
        page: pageEvent,
        eventInfo,
        componentInfo,
      })
    }
  }
}

export const getPromoEventInfo = (ctatitle, ctalink, parent) => {
  let eventInfo
  if (
    typeof window !== "undefined" &&
    window.location?.pathname?.includes("search")
  ) {
    eventInfo = {
      eventAction: `search results:products:main content area:${ctatitle}`,
      eventName: `search results:products:main content area:${ctatitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: ctatitle,
      internalLinkPosition: "search",
      internalLinkType: "search results:internal campaign",
      internalLinkZoneName: "search results:products:main content area",
      internalLinkURL: window.location.origin + ctalink,
      clickInternalLinks: "true",
    }
  } else if (parent?.toLowerCase() === "Dynamic Search") {
    eventInfo = {
      eventAction: `search results:products:main content area:${ctatitle}`,
      eventName: `search results:products:main content area:${ctatitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: ctatitle,
      internalLinkPosition: "suggested search",
      internalLinkType: "suggested search results:internal campaign",
      internalLinkZoneName: "suggested search results:top products results",
      internalLinkURL:
        typeof window !== "undefined" ? window.location.origin + ctalink : "",
      clickInternalLinks: "true",
    }
  } else {
    eventInfo = {
      eventAction: `plp:${ctatitle}`,
      eventName: `plp:${ctatitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: ctatitle,
      internalLinkPosition: "plp",
      internalLinkType: "plp:internal campaign",
      internalLinkZoneName: "plp:promo tiles",
      internalLinkURL:
        typeof window !== "undefined" ? window.location.origin + ctalink : "",
      clickInternalLinks: "true",
    }
  }
  return eventInfo
}
